var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "myCustomer-tree-grid" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "flex-direction": "row", flex: "1" }
        },
        [
          _c("ul", { staticClass: "custom-category-list section" }, [
            _c(
              "li",
              {
                class: [_vm.customerStatusCode === -1 ? "active" : ""],
                attrs: { no: "1" },
                on: {
                  click: function($event) {
                    return _vm.categoryClick(-1)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_All")) +
                    "(" +
                    _vm._s(_vm.allCustomerCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "potential",
                class: [_vm.customerStatusCode === 0 ? "active" : ""],
                attrs: { no: "2" },
                on: {
                  click: function($event) {
                    return _vm.categoryClick(0)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_PotentialStage")) +
                    "(" +
                    _vm._s(_vm.potentialCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "contemplation",
                class: [_vm.customerStatusCode === 1 ? "active" : ""],
                attrs: { no: "3" },
                on: {
                  click: function($event) {
                    return _vm.categoryClick(1)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_IntentionStage")) +
                    "(" +
                    _vm._s(_vm.contemplationCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "business",
                class: [_vm.customerStatusCode === 2 ? "active" : ""],
                attrs: { no: "4" },
                on: {
                  click: function($event) {
                    return _vm.categoryClick(2)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_NegotiationStage")) +
                    "(" +
                    _vm._s(_vm.businessCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "cooperation",
                class: [_vm.customerStatusCode === 3 ? "active" : ""],
                attrs: { no: "5" },
                on: {
                  click: function($event) {
                    return _vm.categoryClick(3)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_CooperationStage")) +
                    "(" +
                    _vm._s(_vm.cooperationCount) +
                    ")"
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  attrs: {
                    "config-module": _vm.modelType === 0 ? "231502" : "231505",
                    reset: true,
                    "custom-sim-query-placeholder": _vm.$t(
                      "CargoMsg.Cargo_CustomerQuickSearch"
                    ),
                    "custom-search-items": _vm.customSearchItems,
                    no: "6"
                  },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              parseInt(_vm.customerStatusCode) ===
                              parseInt(
                                _vm.CrmCustomerConstants.STAGE_COOPERATION.code
                              ),
                            type: "primary",
                            no: "7"
                          },
                          on: {
                            click: function($event) {
                              return _vm.createHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Enter")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.selectedJob || _vm.total <= 0,
                            type: "success",
                            no: "8"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toLook()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType === 0 &&
                                _vm.$checkPermission([
                                  "role_CRMMyCustomerManager_sign"
                                ]),
                              expression:
                                "modelType === 0 && $checkPermission(['role_CRMMyCustomerManager_sign'])"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.selectedJob,
                            type: "primary",
                            no: "9"
                          },
                          on: {
                            click: function($event) {
                              return _vm.signHandler(_vm.modelType)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SignContract")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType === 0 &&
                                _vm.$checkPermission([
                                  "button_CRMMyCustomerManager_release"
                                ]),
                              expression:
                                "modelType === 0 && $checkPermission(['button_CRMMyCustomerManager_release'])"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.selectedJob,
                            type: "primary",
                            no: "10"
                          },
                          on: {
                            click: function($event) {
                              return _vm.releaseHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Release")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 0,
                              expression: "modelType === 0"
                            }
                          ],
                          attrs: { type: "primary", no: "11" },
                          on: {
                            click: function($event) {
                              return _vm.btnInitTemplateClickHandler()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.downloadImportTemplate"))
                          )
                        ]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 0,
                              expression: "modelType === 0"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "padding-left": "5px"
                          },
                          attrs: {
                            action: _vm.actionUrl,
                            headers: { sessionId: _vm.$store.getters.token },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            no: "12",
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadSuccess
                          }
                        },
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.batchImport")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 0,
                              expression: "modelType === 0"
                            }
                          ],
                          staticStyle: { "margin-left": "5px" },
                          attrs: {
                            disabled: !(
                              _vm.selectedJobs && _vm.selectedJobs.length === 1
                            ),
                            type: "primary",
                            no: "newEventRecord"
                          },
                          on: {
                            click: function($event) {
                              return _vm.newEventRecordHandler()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_newEventRecord"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 1,
                              expression: "modelType === 1"
                            }
                          ],
                          staticStyle: { "margin-left": "5px" },
                          attrs: { type: "primary", no: "13" },
                          on: {
                            click: function($event) {
                              return _vm.releaseHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Release")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 1,
                              expression: "modelType === 1"
                            }
                          ],
                          attrs: { type: "primary", no: "14" },
                          on: {
                            click: function($event) {
                              return _vm.assignHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Distribution")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType === 1 &&
                                _vm.$checkPermission([
                                  "role_CRMMyGroupCustomerManager_sign"
                                ]),
                              expression:
                                "modelType === 1 && $checkPermission(['role_CRMMyGroupCustomerManager_sign'])"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.selectedJob,
                            type: "primary",
                            no: "15"
                          },
                          on: {
                            click: function($event) {
                              return _vm.signHandler(_vm.modelType)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SignContract")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 1,
                              expression: "modelType === 1"
                            }
                          ],
                          attrs: { type: "primary", no: "16" },
                          on: {
                            click: function($event) {
                              return _vm.additionalHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExtendPeriod")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType === 1 &&
                                !(
                                  _vm.$checkPermission([
                                    "role_hideAllExports"
                                  ]) && !_vm.$store.getters.isAdmin
                                ),
                              expression:
                                "modelType === 1 && !($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)"
                            }
                          ],
                          attrs: { type: "primary", no: "17" },
                          on: {
                            click: function($event) {
                              return _vm.exportExcelEvent()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExcelExport")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType === 1,
                              expression: "modelType === 1"
                            }
                          ],
                          attrs: { type: "primary", no: "18" },
                          on: {
                            click: function($event) {
                              return _vm.deleteHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "min-height": "350px" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module":
                        _vm.modelType === 0 ? "23150200" : "23150500",
                      "grid-options": _vm.gridOptions,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      },
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      no: "19"
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module":
                        _vm.modelType === 0 ? "23150201" : "23150501",
                      total: _vm.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize,
                      no: "20"
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: function($event) {
                        return _vm.toQuery()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.signMatchTitleWindow.visible
        ? _c("sign-match-title-window", {
            attrs: {
              visible: _vm.signMatchTitleWindow.visible,
              "enabled-no-join": true,
              client: _vm.selectedJob || {},
              no: "21"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.signMatchTitleWindow, "visible", $event)
              },
              signSuccessCallBack: _vm.signSuccessCallBackHandler
            }
          })
        : _vm._e(),
      _vm.customerAssignWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.customerAssignWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_Distribution"),
                width: "360px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.customerAssignWindow, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.sales") } },
                    [
                      _c("cargo-user-select", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          "method-params": { category: "role", shape: "sales" },
                          "default-value": _vm.customerAssignWindow.sales || "",
                          no: "22"
                        },
                        on: {
                          change: function(p) {
                            _vm.customerAssignWindow.sales = p.value || 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "23" },
                      on: { click: _vm.enterAssignHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "24" },
                      on: {
                        click: function($event) {
                          _vm.customerAssignWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.customerAdditionalWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.customerAdditionalWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_ExtendPeriod"),
                width: "360px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.customerAdditionalWindow,
                    "visible",
                    $event
                  )
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "padding-left": "40px" },
                      attrs: {
                        label: _vm.customerAdditionalWindow.isPartner
                          ? _vm.$t("CargoMsg.Cargo_DaysOfSleep")
                          : _vm.$t("CargoMsg.Cargo_DaysFromContractSigned")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          max: 2147483647,
                          precision: 0,
                          "controls-position": "right",
                          no: "25"
                        },
                        model: {
                          value: _vm.customerAdditionalWindow.days,
                          callback: function($$v) {
                            _vm.$set(_vm.customerAdditionalWindow, "days", $$v)
                          },
                          expression: "customerAdditionalWindow.days"
                        }
                      }),
                      _c("span", { staticStyle: { "padding-left": "10px" } }, [
                        _vm._v(_vm._s(_vm.$t("Partners.day")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "26" },
                      on: { click: _vm.enterAdditionalHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "27" },
                      on: {
                        click: function($event) {
                          _vm.customerAdditionalWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.eventRecordDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                id: "eventRecordDialog",
                visible: _vm.eventRecordDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_EventRecord"),
                width: "600px",
                "close-on-click-modal": false,
                "append-to-body": "",
                no: "100"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.eventRecordDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-main-inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_theme"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_PleaseSelectP"
                                ),
                                size: "mini",
                                no: "101"
                              },
                              model: {
                                value: _vm.eventRecordDialog.form.titleName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.eventRecordDialog.form,
                                    "titleName",
                                    $$v
                                  )
                                },
                                expression: "eventRecordDialog.form.titleName"
                              }
                            },
                            _vm._l(
                              _vm.CrmCustomerConstants.CUSTOMER_EVENT_SUBJECTS,
                              function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_TaskTime") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              clearable: false,
                              "picker-options": _vm.pickerOptions,
                              format: "yyyy-MM-dd HH:mm",
                              disabled: !_vm.eventRecordDialog.isEditTime,
                              editable: false,
                              no: "102"
                            },
                            model: {
                              value: _vm.eventRecordDialog.form.taskTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "taskTime",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.taskTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Recorder") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: true, no: "8" },
                            model: {
                              value: _vm.eventRecordDialog.form.recorderName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "recorderName",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.recorderName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_RecordTime") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              disabled: true,
                              no: "103"
                            },
                            model: {
                              value: _vm.eventRecordDialog.form.recordTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "recordTime",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.recordTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EventStatus"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_PleaseSelectP"
                                ),
                                size: "mini",
                                no: "104"
                              },
                              model: {
                                value: _vm.eventRecordDialog.form.status,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.eventRecordDialog.form,
                                    "status",
                                    $$v
                                  )
                                },
                                expression: "eventRecordDialog.form.status"
                              }
                            },
                            _vm._l(
                              _vm.CrmCustomerConstants.CUSTOMER_EVENT_STATUSS,
                              function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Location") } },
                        [
                          _c("el-input", {
                            attrs: { no: "105" },
                            model: {
                              value: _vm.eventRecordDialog.form.address,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "address",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.address"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_Participant") }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "106" },
                            model: {
                              value: _vm.eventRecordDialog.form.participants,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "participants",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.participants"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ContentDescription")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 9, no: "107" },
                            model: {
                              value: _vm.eventRecordDialog.form.content,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "content",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.content"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Outcomes") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "108" },
                            model: {
                              value: _vm.eventRecordDialog.form.achievement,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "achievement",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.achievement"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_NextStep") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "109" },
                            model: {
                              value: _vm.eventRecordDialog.form.nextTask,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "nextTask",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.nextTask"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_ReportTo") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 2, no: "110" },
                            model: {
                              value: _vm.eventRecordDialog.form.reportTarget,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "reportTarget",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.reportTarget"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "111" },
                            model: {
                              value: _vm.eventRecordDialog.form.remarks,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "remarks",
                                  $$v
                                )
                              },
                              expression: "eventRecordDialog.form.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SupervisorComments")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              disabled: !_vm.eventRecordDialog
                                .editSupervisorComments,
                              no: "112"
                            },
                            model: {
                              value:
                                _vm.eventRecordDialog.form.supervisorComments,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.eventRecordDialog.form,
                                  "supervisorComments",
                                  $$v
                                )
                              },
                              expression:
                                "eventRecordDialog.form.supervisorComments"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "113" },
                      on: { click: _vm.recordDialogSave }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "114" },
                      on: { click: _vm.recordDialogClose }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }